module.exports = __webpack_public_path__ + "img/Group_1.9c4b9f95.png";